import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useUserDetails } from "../../../context/auth";
import sign from "../../../assest/images/Singn.png";
import moment from "moment";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ReusablePDFLayout from "../ReusablePDFLayout";

export const Nda = () => {
  const pdfRef = useRef();
  const {RowIDdata} = useUserDetails();

  const generatePDF = async () => {
    const input = pdfRef.current;
    const pdf = new jsPDF("p", "mm", "a4");
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    // Add the first page
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Loop to handle multi-page content (if heightLeft is more than 0, continue adding pages)
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Save PDF
    pdf.save("npa.pdf");
  };
const Dateformat = moment(new Date().toLocaleDateString()).format("DD MMMM YYYY");
  return (
    <DashboardLayout>
      <div>
      <button onClick={generatePDF} 
           style={{
            margin: "20px",
            padding: "10px",
            backgroundColor: "#007BFF",
            color: "#fff",
            border: "none",
            cursor:'pointer',
            borderRadius: "5px",
            fontSize: "14px",
          }}
        >Download PDF</button>

        {/* Parent container for PDF */}
        <div
          ref={pdfRef}
          style={{
            backgroundColor: "white", // Ensure proper background
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "210mm",
            padding: "0",
              marginLeft:'10%'
          }}
        >
          <ReusablePDFLayout>
            <div className="parentcls">
              <p className="bol">
                <span style={{ borderBottom: "2px solid black" }}>
                  NON DISCLOSURE AGREEMENT
                </span>{" "}
              </p>
              <p className="newpara">
                This Agreement is made on{" "}
                <span className="bolds">{Dateformat} </span> by and between{" "}
                <span className="bolds">
                  Keel Info Solution Private Limited
                </span>{" "}
                , a company incorporated under the Companies Act, 1956, having
                its registered office at{" "}
                <span className="bolds">
                  No.73, Esic nagar,2nd floor, Santo complex,150ft agaram main
                  road, Thiruvancherry, Chennai-600126
                </span>{" "}
                ,(hereinafter referred to as{" "}
                <span className="bolds">"Company"</span>) and
                <span className="bolds">[{RowIDdata[0]?.candidateName}],{RowIDdata[0]?.location}</span>.
                (hereinafter referred to as "Employee").{" "}
                <span className="bolds">Company</span> and the Employee shall be
                collectively referred to as the "Parties".
              </p>
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>1.</p>
                <p className="para">
                  <span className="bolds">
                    Definition of Confidential Information.
                  </span>{" "}
                  "Confidential Information" shall mean any and all technical
                  and non-technical information including patent, copyright,
                  trade secret, and proprietary information, techniques,
                  sketches, drawings, models, inventions, know-how, processes,
                  equipment, software programs, software source documents, and
                  includes, without limitation, its respective information
                  concerning research, experimental work, development, design
                  details and specifications, engineering, financial
                  information, procurement requirements, customer lists,
                  business forecasts, sales and marketing plans, strategic plans
                  and like information. "Confidential Information" also includes
                  proprietary or confidential information about any third party
                  who may disclose such information to
                  <span className="bolds"> Company </span>
                  during business discussions.
                </p>
              </div>
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>2.</p>
                <p className="para">
                  <span className="bolds">
                    Nondisclosure and Nonuse Obligations.
                  </span>{" "}
                  Employee agrees that he/she shall not make use of,
                  disseminate, or in any way disclose Confidential Information
                  to any person, firm, or business, except to the extent
                  necessary for negotiations, discussions, and consultations
                  with personnel or authorized representatives of the{" "}
                  <span className="bolds">Company</span> . Furthermore, the
                  existence of any business negotiations, discussions,
                  consultations, or agreements in progress between the Parties
                  shall not be released to any form of public media without the
                  prior written approval of either party. Parties agree that
                  they should treat all Confidential Information of either party
                  with the same degree of care as it accords to its own
                  Confidential Information. Employee agrees that he/she shall
                  disclose Confidential Information of{" "}
                  <span className="bolds">Company</span> only to those of its
                  employees who need to know such information and certifies that
                  such employees have previously agreed, either as a condition
                  of employment or to obtain the Confidential Information, to be
                  bound by terms and conditions substantially like those of this
                  Agreement. Employees shall immediately give notice to{" "}
                  <span className="bolds">Company</span> of any unauthorized use
                  or disclosure of Confidential Information.
                </p>
              </div>
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>3.</p>
                <p className="para">
                  <span className="bolds">
                    Ownership of Confidential Information and Other Materials.
                  </span>{" "}
                  All Confidential Information and any Derivatives thereof,
                  whether created by the Employee, remains the property of
                  Company and no license or other rights to Confidential
                  Information is granted or implied hereby. For purposes of this
                  Agreement, "Derivatives" shall mean:
                </p>
              </div>
            </div>
          </ReusablePDFLayout>
          <ReusablePDFLayout>
            <div className="parentcls">
              <p className="newpara">
                (i) for copyrightable or copyrighted material, any translation,
                abridgment, revision or other form in which an existing work may
                be recast, transformed or adapted; (ii) for patentable or
                patented material, any improvement thereon; and (iii) for
                material which is protected by trade secret, any new material
                derived from such existing trade secret material, including new
                material which may be protected by copyright, patent and/or
                trade secret. All materials (including, without limitation,
                documents, drawings, models, design, and lists) furnished to
                Employee by {" "}
                <span className="bolds">KEEL INFO SOLUTION PRIVATE LIMITED</span>{' '} , and which are
                designated in writing to be the property of {" "}
                <span className="bolds">Company</span>{' '}, shall
                remain the property of {" "}
                <span className="bolds">Company</span>{' '} and shall be returned to {" "}
                <span className="bolds">Company</span>{' '}
                promptly at Company's request, together with any copies thereof.
              </p>
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>4.</p>
                <p className="para">
                  <span className="bolds">No Warranty.</span> All Confidential
                  Information is provided "AS IS" and without any warranty,
                  express, implied, or otherwise, regarding its accuracy or
                  performance.
                </p>
              </div>
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>5.</p>
                <p className="para">
                  <span className="bolds">Term.</span> All Confidential This
                  Agreement shall be valid during the tenure of the Employee's
                  employment with{" "}
                  <span className="bolds">KEEL INFO SOLUTION PRIVATE LIMITED</span>{' '}  and
                  thereafter for a period of One year.
                </p>
              </div>
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>6.</p>
                <p className="para">
                  <span className="bolds"> Notices.</span>
                  Any notice required or permitted by this Agreement shall be in
                  writing and shall be delivered as follows with notice deemed
                  given as indicated: (i) by personal delivery when delivered
                  personally; (ii) by overnight courier upon written
                  verification of receipt; (iii) by telecopy or facsimile
                  transmission upon acknowledgment of receipt of electronic
                  transmission; or (iv) by certified or registered mail, return
                  receipt requested, upon verification of receipt. Notice shall
                  be sent to the addresses set forth above or such other address
                  as either Party may specify in writing.
                </p>
              </div>
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>7.</p>
                <p className="para">
                  <span className="bolds"> Governing Law.</span>
                  This Agreement shall be governed by and construed in
                  accordance with the laws of India.
                </p>
              </div>
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>8.</p>
                <p className="para">
                  <span className="bolds"> Severability.</span>
                  Should any provisions of this Agreement be held by a court of
                  law to be illegal, invalid, or unenforceable, the legality,
                  validity, and enforceability of the remaining provisions of
                  this Agreement shall not be affected or impaired thereby.
                </p>
              </div>
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>9.</p>
                <p className="para">
                  <span className="bolds"> Injunctive Relief.</span>A breach of
                  any of the promises or agreements contained herein shall
                  result in irreparable and continuing damage to{" "}
                  <span className="bolds">Company</span>{" "} for which there shall
                  be no adequate remedy at law, and{" "}
                  <span className="bolds">Company</span>{' '}
                  shall be entitled to injunctive relief and/or a decree for
                  specific performance, and such other relief as may be proper
                  (including monetary damages if appropriate).
                </p>
              </div>
            </div>
          </ReusablePDFLayout>
          <ReusablePDFLayout>
            <div className="parentcls">
              <div className="rowparent">
                <p style={{ marginRight: "14px", fontSize: "15px" }}>10.</p>
                <p className="para">
                  <span className="bolds"> Entire Agreement.</span>
                  This Agreement constitutes the entire agreement with respect
                  to the Confidential Information disclosed herein and
                  supersedes all prior oral or written agreements concerning
                  such Confidential Information. This Agreement may only be
                  changed by mutual agreement of the Parties in writing.
                </p>
              </div>
              <p className="newpara">
                IN WITNESS WHEREOF, the Parties have executed this Agreement as
                of the date first written above.
              </p>
              <div className="rowparent" style={{marginTop:"55px"}}>
                <div style={{ width: "50%" }}>
                  <p className="bolds">For KEEL INFO SOLUTION</p>
                  <div
                    className="rowparent"
                    style={{
                      justifyContent: "space-between",
                      gap: "2px",
                      marginBottom: "5px",
                    }}
                  >
                    <p style={{ marginTop: "20px" }} className="para">
                      Signature :
                    </p>
                    <div style={{ marginRight: "55px" }}>
                      <img src={sign} width={"180px"} />
                    </div>
                  </div>
                  <div
                    className="rowparent"
                    style={{
                      justifyContent: "space-between",
                      gap: "2px",
                      marginTop: "5px",
                    }}
                  >
                    <p style={{ marginTop: "0px" }} className="para">
                      Name :
                    </p>
                    <div style={{ marginRight: "190px" }}>
                      <p className="para">Vishali</p>
                    </div>
                  </div>
                  <div
                    className="rowparent"
                    style={{ justifyContent: "space-between", gap: "2px" }}
                  >
                    <p style={{ marginTop: "0px" }} className="para">
                      Title :
                    </p>
                    <div style={{ marginRight: "130px" }}>
                      <p className="para">People Manager</p>
                    </div>
                  </div>
                  <div
                    className="rowparent"
                    style={{ justifyContent: "space-between", gap: "2px" }}
                  >
                    <p style={{ marginTop: "0px" }} className="para">
                      Date :
                    </p>
                    <div style={{ marginRight: "160px" }}>
                      <p className="para">77.22.2222</p>
                    </div>
                  </div>
                </div>
                <div style={{ width: "50%" }}>
                  <p className="bolds">For EMPLOYEE</p>

                  <p style={{ marginTop: "50px" }} className="para">
                    Signature : ___________________________
                  </p>
                  <p style={{ marginTop: "25px" }} className="para">
                    Name <span style={{ marginLeft: "25px" }}> :</span>{" "}
                    ___________________________
                  </p>
                  <p style={{ marginTop: "25px" }} className="para">
                    Title <span style={{ marginLeft: "29px" }}> :</span>{" "}
                    ___________________________
                  </p>
                  <p style={{ marginTop: "25px" }} className="para">
                    Date <span style={{ marginLeft: "28px" }}> :</span>{" "}
                    ___________________________
                  </p>
                  {/* <div style={{marginTop:"0px"}}> */}

                  {/* </div> */}
                </div>
              </div>
            </div>
          </ReusablePDFLayout>
        </div>
      </div>
    </DashboardLayout>
  );
};
